import UrlPattern from "url-pattern"

export const getUrl = (pattern, params = {}) => {

    return process.env.REACT_APP_API_ENDPOINT + (
        new UrlPattern(pattern)
    ).stringify(params)
}